import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import * as general from '../libs/general';

const OMNICHANNEL_PATH = '/admin/omnichannel';

function RouteLogger() {
  const location = useLocation();
  const prevPathRef = useRef(null);

  useEffect(() => {
    var currentUrl = location.pathname + location.search + location.hash;
    general.pushUrl(currentUrl);

  }, [location]);

  // Soft navigate (SPA) tới omnichannel → reload toàn trang để Trade Portal mount sạch.
  useEffect(() => {
    const prev = prevPathRef.current;
    const next = location.pathname;
    if (prev !== null && next === OMNICHANNEL_PATH && prev !== next) {
      window.location.reload();
      return;
    }
    prevPathRef.current = next;
  }, [location.pathname]);

  return null;
};
export default RouteLogger;
